import axios from './axios';

export const orderService = {
    // order list
  fetchOrderlist: async (userId,rowsPerPage,page) => {
    try {
      const response = await axios.get(`/order/history?per_page=${rowsPerPage}&page=${page}`);
      return response;
    } catch (error) {
      return error.response;
    }
  },
//   order detail by id
    fetchOrderDetail: async (orderId) => {
        try {
        const response = await axios.get(`/order/${orderId}`);
        return response;
        } catch (error) {
        return error.response;
        }
    },
};